if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
     
      // --- Scroll unlock failsafe (ADD THIS BLOCK) ---
      const html = document.documentElement;
      const body = document.body;

      html.classList.remove('no-scroll','overflow-hidden','modal-open','cart-open','drawer-open');
      body.classList.remove('no-scroll','overflow-hidden','modal-open','cart-open','drawer-open','scroll-locked');

      // If the theme/app used fixed-position locking, restore it
      const top = body.style.top;
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      if (top) {
        const y = -parseInt(top || '0', 10);
        if (!isNaN(y)) window.scrollTo(0, y);
      }
      // --- end failsafe ---
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.ensureQuickAddFetchPatch();
          this.removeDOMElements();
          const mediaGallery = this.productElement.querySelector('media-gallery');
          if (mediaGallery) {
            mediaGallery.dataset.disablePrepend = 'false';
            mediaGallery.removeAttribute('data-filtering-option');
            mediaGallery.querySelectorAll('.product__media-item.hidden, .thumbnail-list__item.hidden').forEach(item => {
              console.log(item)
              item.classList.remove('hidden');
            })
          }
          if (this.productElement.querySelector('variant-selects')) this.productElement.querySelector('variant-selects').dataset.hasFiltering = 'false';
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          this.initializePaymentButtons();

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          this.initializeVariantSelection();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const stickyAtc = this.productElement.querySelector('sticky-atc');
      if (stickyAtc) stickyAtc.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.sectionId || this.productElement.dataset.section;
      if (!sectionId) return;

      const quickaddSectionId = `quickadd-${ sectionId }`;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, quickaddSectionId);

      this.productElement
        .querySelectorAll('variant-selects, variant-radios, product-info, product-form')
        .forEach((element) => {
          element.dataset.originalSection = sectionId;
        });

      window.__quickAddSectionMap = window.__quickAddSectionMap || {};
      window.__quickAddSectionMap[quickaddSectionId] = sectionId;
    }

    ensureQuickAddFetchPatch() {
      if (window.__quickAddFetchPatched) return;

      const rewriteSectionId = (url) => {
        if (!url || typeof url !== 'string') return url;
        const match = url.match(/section_id=([^&]+)/);
        if (!match) return url;

        const sectionId = decodeURIComponent(match[1]);
        const original = window.__quickAddSectionMap && window.__quickAddSectionMap[sectionId];
        if (!original) return url;

        return url.replace(`section_id=${match[1]}`, `section_id=${encodeURIComponent(original)}`);
      };

      if (window.fetch) {
        const originalFetch = window.fetch.bind(window);
        window.fetch = (resource, init) => {
          let url = typeof resource === 'string' ? resource : resource && resource.url;
          const rewritten = rewriteSectionId(url);
          if (rewritten && rewritten !== url) {
            if (typeof resource === 'string') {
              resource = rewritten;
            } else if (resource instanceof Request) {
              resource = new Request(rewritten, resource);
            }
          }
          return originalFetch(resource, init);
        };
      }

      if (window.XMLHttpRequest) {
        const originalOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function(method, url, ...rest) {
          const rewritten = rewriteSectionId(url);
          return originalOpen.call(this, method, rewritten || url, ...rest);
        };
      }

      window.__quickAddFetchPatched = true;
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }


    initializePaymentButtons() {
      if (!this.modalContent.querySelector('.shopify-payment-button')) return;

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
        return;
      }

      if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([
          {
            name: 'payment-button',
            version: '1.0',
            onLoad: (errors) => {
              if (errors || !Shopify.PaymentButton) return;
              Shopify.PaymentButton.init();
            },
          },
        ]);
      }
    }

    initializeVariantSelection() {
      const variantPicker = this.modalContent.querySelector('variant-selects,variant-radios');
      if (!variantPicker) return;

      const variantData = variantPicker.querySelector('script[type="application/json"]');
      if (!variantData) return;

      let variants = [];
      try {
        variants = JSON.parse(variantData.textContent || '[]');
      } catch (error) {
        console.warn('Quick add variant data parse failed.', error);
        return;
      }

      const productFormElement = this.modalContent.querySelector('product-form');
      const form = this.modalContent.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      const idInput = form.querySelector('input[name="id"]');
      const submitButton = form.querySelector('button[name="add"], button[type="submit"]');
      if (!idInput || !submitButton) return;

      const variantsById = new Map(variants.map(variant => [String(variant.id), variant]));
      const optionNames = productFormElement?.dataset?.options
        ? productFormElement.dataset.options.split(',').map(option => option.trim()).filter(Boolean)
        : [];

      const escapeCss = (value) => {
        if (window.CSS && CSS.escape) return CSS.escape(value);
        return value.replace(/["\\]/g, '\\$&');
      };

      const collectOptionValues = () => {
        const optionGroups = Array.from(variantPicker.querySelectorAll('.product-form__input'));
        if (optionGroups.length) {
          return optionGroups.map(group => {
            const checked = group.querySelector('input[type="radio"]:checked');
            if (checked) return checked.value;
            const select = group.querySelector('select');
            return select ? select.value : '';
          });
        }

        return optionNames.map(optionName => {
          const escapedName = escapeCss(optionName);
          const radio = variantPicker.querySelector(
            `input[type="radio"][name="${escapedName}"]:checked, input[type="radio"][name^="${escapedName}"]:checked`
          );
          if (radio) return radio.value;

          const select = variantPicker.querySelector(
            `select[name="options[${optionName}]"], select[name="${escapedName}"]`
          );
          return select ? select.value : '';
        });
      };

      const syncVariantId = (variantId) => {
        const nextValue = String(variantId || '');
        if (!nextValue) return;

        const idInputs = Array.from(this.modalContent.querySelectorAll('input[name="id"], input.product-variant-id'));
        idInputs.forEach((input) => {
          const currentValue = String(input.value || '');
          if (currentValue === nextValue && input.getAttribute('value') === nextValue) return;

          input.value = nextValue;
          input.setAttribute('value', nextValue);
          input.disabled = false;
          input.removeAttribute('disabled');
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      };


      const updateButtonState = (variant) => {
        if (!variant) {
          submitButton.setAttribute('disabled', 'disabled');
          submitButton.setAttribute('data-unavailable', 'true');
          const label = submitButton.querySelector('.main-atc__label__text');
          if (label && window.variantStrings?.unavailable) label.textContent = window.variantStrings.unavailable;
          return;
        }

        syncVariantId(variant.id);
        if (variant.available) {
          submitButton.removeAttribute('disabled');
          submitButton.removeAttribute('data-unavailable');
          const label = submitButton.querySelector('.main-atc__label__text');
          if (label) label.textContent = submitButton.dataset.customLabel || window.variantStrings?.addToCart || label.textContent;
        } else {
          submitButton.setAttribute('disabled', 'disabled');
          submitButton.setAttribute('data-unavailable', 'true');
          const label = submitButton.querySelector('.main-atc__label__text');
          if (label && window.variantStrings?.soldOut) label.textContent = window.variantStrings.soldOut;
        }
      };

      const getVariantFromSelection = () => {
        const selectedOptions = collectOptionValues();
        if (selectedOptions.length && !selectedOptions.some(value => value === '')) {
          const match = variants.find(variant => {
            if (selectedOptions[0] && variant.option1 !== selectedOptions[0]) return false;
            if (selectedOptions[1] && variant.option2 !== selectedOptions[1]) return false;
            if (selectedOptions[2] && variant.option3 !== selectedOptions[2]) return false;
            return true;
          });
          if (match) return match;
        }

        const variantFromId = variantsById.get(String(idInput.value || ''));
        if (variantFromId) return variantFromId;

        return null;
      };

      const updateFromSelection = () => {
        const match = getVariantFromSelection();
        updateButtonState(match || null);
      };

      let rafId = null;
      const scheduleUpdate = () => {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          rafId = null;
          updateFromSelection();
        });
      };

      let isForcingSubmit = false;

      updateFromSelection();
      variantPicker.addEventListener('change', scheduleUpdate);
      variantPicker.addEventListener('input', scheduleUpdate);
      form.addEventListener('change', scheduleUpdate);
      form.addEventListener('submit', (event) => {
        if (isForcingSubmit) return;

        const match = getVariantFromSelection();
        if (!match) return;

        const currentId = String(idInput.value || '');
        const nextId = String(match.id || '');
        if (currentId === nextId) return;

        event.preventDefault();
        syncVariantId(nextId);
        isForcingSubmit = true;

        if (productFormElement && typeof productFormElement.handleSubmit === 'function') {
          productFormElement.handleSubmit(event);
        } else if (form.requestSubmit && submitButton) {
          form.requestSubmit(submitButton);
        } else {
          form.submit();
        }

        setTimeout(() => {
          isForcingSubmit = false;
        }, 0);
      });

      const observer = new MutationObserver(scheduleUpdate);
      observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      observer.observe(submitButton, { attributes: true, attributeFilter: ['disabled'] });

      setTimeout(scheduleUpdate, 0);
      setTimeout(scheduleUpdate, 50);
      setTimeout(scheduleUpdate, 250);
    }
  });
}
